import React from 'react';

type SplitMinuteTimeInputProps = {
  value?: string;
  initialTime?: string;
  onChange?: (time: string) => void;
};

const hours = Array.from({ length: 24 }, (_, hour) => String(hour).padStart(2, '0'));
const minutes = Array.from({ length: 60 }, (_, minute) => String(minute).padStart(2, '0'));

const SplitMinuteTimeInput: React.FC<SplitMinuteTimeInputProps> = ({ value = '', initialTime = '', onChange }) => {
  const match = /^(\d{2}):(\d{2})$/.exec(value || initialTime);
  const hour = match?.[1] ?? '';
  const minute = match?.[2] ?? '';

  return (
    <div className="split-minute-time-input">
      <select
        aria-label="時"
        value={hour}
        onChange={(event) => onChange?.(`${event.target.value}:${minute || '00'}`)}
      >
        <option value="" disabled>時</option>
        {hours.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
      <span>:</span>
      <select
        aria-label="分"
        value={minute}
        disabled={!hour}
        onChange={(event) => onChange?.(`${hour}:${event.target.value}`)}
      >
        <option value="" disabled>分</option>
        {minutes.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
    </div>
  );
};

export default SplitMinuteTimeInput;
